var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chat-btm-section-main width-full float-l"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-web-section chat-user-list-main float-l width-full"
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "chat-page-title float-l colpie-80 color-333333 heading-text-24 line-height-28 font-bold ucase"
                              },
                              [_vm._v(" Users ")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "logout-btn float-r" }),
                            _vm._v(" "),
                            _c(
                              "vue-good-table",
                              {
                                ref: "listUserList",
                                attrs: {
                                  mode: "remote",
                                  title: "User",
                                  totalRows: _vm.totalRecords,
                                  columns: _vm.columns,
                                  rows: _vm.rows,
                                  "pagination-options": {
                                    enabled: true,
                                    position: "bottom",
                                    perPage: 10,
                                    dropdownAllowAll: false
                                  },
                                  "select-options": {
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: "custom-class",
                                    selectionText: "rows selected",
                                    clearSelectionText: "Clear"
                                  },
                                  "search-options": {
                                    enabled: false
                                  }
                                },
                                on: {
                                  "on-page-change": _vm.onPageChange,
                                  "on-selected-rows-change":
                                    _vm.selectionChanged,
                                  "on-column-filter": _vm.onColumnFilter,
                                  "on-per-page-change": _vm.onPerPageChange,
                                  "on-sort-change": _vm.onSortChange
                                },
                                scopedSlots: _vm._u(
                                  [
                                    _vm._l(_vm.rows, function(row, key) {
                                      return {
                                        key: "table-row",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                key: key,
                                                staticClass: "user-list-view"
                                              },
                                              [
                                                props.column.field == "action"
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Edit User",
                                                              to: {
                                                                name:
                                                                  "UserEdit",
                                                                params: {
                                                                  id:
                                                                    props.row.id
                                                                }
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                props.column.field ==
                                                "sectionRoleHtml"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btn-center-vvg"
                                                      },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              props
                                                                .formattedRow[
                                                                props.column
                                                                  .field
                                                              ]
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            props.formattedRow[
                                                              props.column.field
                                                            ]
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ])
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    })
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "selected-row-actions" },
                                    slot: "selected-row-actions"
                                  },
                                  [
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-success waves-effect row-deactivate-btn",
                                          attrs: { id: "deleteGroupBtn" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.activeOrInactiveState(
                                                "De Activate"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("De Activate")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-success waves-effect row-activate-btn",
                                          attrs: { id: "deleteGroupBtn" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.activeOrInactiveState(
                                                "Activate"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Activate")]
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "user-list-mobile float-l width-full"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mobile-class-userlist" },
                              [
                                !_vm.mobileButtonHideShow
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mobile-active-deactive-button vgt-selection-info-row__actions vgt-pull-right"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success waves-effect row-deactivate-btn",
                                            attrs: { id: "deleteGroupBtn" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.activeOrInactiveState(
                                                  "De Activate"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("De Activate")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success waves-effect row-activate-btn",
                                            attrs: { id: "deleteGroupBtn" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.activeOrInactiveState(
                                                  "Activate"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Activate")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userArray && _vm.userArray.length > 0
                                  ? _vm._l(_vm.userArray, function(
                                      user,
                                      userIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-list-section col-12 float-l relative pt_20 pb_20"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              key: userIndex,
                                              staticClass:
                                                "custom-control custom-checkbox mb_3"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-control-label float-l width-full heading-text-16 line-height-20 color-333333 font-benton-medium pl_15",
                                                  attrs: { for: "customCheck" }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.userCheckbox,
                                                        expression:
                                                          "userCheckbox"
                                                      }
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      id:
                                                        "customCheck" + user.id
                                                    },
                                                    domProps: {
                                                      value: user.id,
                                                      checked: Array.isArray(
                                                        _vm.userCheckbox
                                                      )
                                                        ? _vm._i(
                                                            _vm.userCheckbox,
                                                            user.id
                                                          ) > -1
                                                        : _vm.userCheckbox
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.userCheckbox,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = user.id,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.userCheckbox = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.userCheckbox = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.userCheckbox = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "user-name-mobile"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "filterUSting"
                                                            )(user.name)
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color-888888 float-l width-full font-text-regular-benton heading-text-13 line-height-17 pt_3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        " +
                                                              _vm._s(
                                                                user.email
                                                              ) +
                                                              "\n                                                    "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    title: "Edit User",
                                                    to: {
                                                      name: "UserEdit",
                                                      params: { id: user.id }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-angle-right"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              : [_vm.isRequestComplete ? [_vm._m(0)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25b5cd00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b5cd00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserList.vue
// module id = null
// module chunks = 